import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import {
  WHIconENUM,
  WHTranslationTypeENUM,
} from '@workheld/workheld-shared-lib';

@Component({
  selector: 'mat-dialog-workobject-close-entry',
  templateUrl: './mat-dialog-workobject-close-entry.component.html',
  styleUrls: ['./mat-dialog-workobject-close-entry.component.scss'],
  standalone: false,
})
export class MatDialogWorkObjectCloseEntryComponent {
  public payloadFormGroup: FormGroup = new FormBuilder().group({
    comment: [null],
    reason: [null, Validators.required],
  });

  ENUMS = WHTranslationTypeENUM;

  constructor(
    public matDialogRef: MatDialogRef<MatDialogWorkObjectCloseEntryComponent>,
  ) {}

  public handleSubmit(): void {
    this.confirmNewStateWorkObject();
  }

  private confirmNewStateWorkObject() {
    const payload: any = this.payloadFormGroup.value;
    payload.comment =
      payload.reason + (payload.comment ? ':::__:::__:::' + payload.comment : '');

    this.matDialogRef.close(payload.comment);
  }

  public get isFormGroupInvalid(): boolean {
    return this.payloadFormGroup.invalid as boolean;
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  public get saveIcon(): string {
    return WHIconENUM.SaveIcon as string;
  }

  public get cancelIcon(): string {
    return WHIconENUM.CancelIcon as string;
  }
}
